import { useBanksCatalogueQuery } from '../graphql/useBanksCatalogue';
import { useCreateClabeMutation } from '../graphql/useCreateClabeMutation';
import { useCreateClabeForm } from './useCrateClabeForm';

export const useController = () => {
  const [createClabeMutation, { loading: isSubmitting }] = useCreateClabeMutation();

  const { data, loading: loadingCatalogue } = useBanksCatalogueQuery();

  const borrowerBanks = data?.catalogs?.borrowerBanks || [];

  const { control, onSubmit } = useCreateClabeForm({
    borrowerBanks,
    createClabeMutation,
  });

  return {
    control,
    onSubmit,
    isSubmitting,
    loadingCatalogue,
  };
};
